<template>
    <header class="header_goods">
     <div class="header_content1">
       <div class="header_logo">
        <img :src="require('@/assets/img/logo.png')" />
       </div>
       <div class="header_menu">
         <el-menu
           :default-active="getDefaultActive"
           class="el-menu-demo"
           mode="horizontal"
         >
           <!-- <el-menu-item-group></el-menu-item-group> 这里可以用group标签包起来的 但是css有冲突 -->
           <el-menu-item v-if="user_type == 1" index="/goods"><router-link class="header_href" to="/goods">创意中心</router-link></el-menu-item>
           <el-menu-item v-if="user_type == 1" index="/demandcaselist"><router-link class="header_href" to="/demandcaselist">案例库</router-link></el-menu-item>
           <el-menu-item v-if="user_type == 1" index="/shoppingcart"><router-link class="header_href" to="/shoppingcart">购物车</router-link></el-menu-item>
           <el-menu-item v-if="user_type == 1" index="/order"><router-link class="header_href"  to="/order">我的订单</router-link></el-menu-item>

           <el-menu-item v-if="user_type == 2 || user_type == 3" index="/servicecaselist"><router-link class="header_href" to="/servicecaselist">案例库</router-link></el-menu-item>
           <el-menu-item v-if="user_type == 2 || user_type == 3" index="/company"><router-link class="header_href" to="/company">公司信息管理</router-link></el-menu-item>
           <el-menu-item v-if="user_type == 2 || user_type == 3" index="/myproject"><router-link class="header_href" to="/myproject">我的项目</router-link></el-menu-item>
         </el-menu>
       </div>
       <div class="header_user">
         <el-tooltip popper-class="tooltip_class" placement="bottom" effect="light" v-if="user_type == 1">
           <div slot="content" class="header_user_service_tooltip">
             <img :src="require('@/assets/img/qrcode.png')"/>
             <p>您可以扫描二维码
               添加企业微信联系客服</p>
           </div>
         <div class="header_user_service">
           <img :src="require('@/assets/img/icon_service.png')" />
           联系客服
         </div>
       </el-tooltip>
       <el-tooltip popper-class="user_tooltip_class" placement="bottom" effect="light">
        <div slot="content" class="header_user_name_tooltip" @click="pwdreset">
          修改密码
        </div>
         <div slot="content" class="header_user_name_tooltip" @click="unlogin">
           退出登录
         </div>
         <div class="header_user_service">
           <img :src="require('@/assets/img/icon_customer.png')" />
           {{userName}}
         </div>
       </el-tooltip>
       </div>
     </div>
   </header>
</template>
<script>
/* eslint-disable */
import Cookies from 'js-cookie'
import * as commfun from "@/common/common.js"
export default {
  name: 'Mainl',
  data() {
    return {
      activeName:"/goods",
      userName: "",
      user_type: '',
    };
  },
  created() {
    this.userName = Cookies.get("userName")
    this.user_type = Cookies.get("type")
    // 自动跳转页面
    if (this.user_type == 1) { // 需求方
      if (this.in_array(this.$route.path, ['/servicecaselist', '/company', '/servicecaseadd', '/servicecasedetail', '/myproject', '/myprojectdetail'])) {
        window.location.href = '/goods'
      }
    } else {  // 服务方
      if (this.in_array(this.$route.path, ['/goods', '/demandcaselist', '/shoppingcart', '/order', '/orderdetail', '/detail', '/demandcasedetail'])) {
        window.location.href = '/servicecaselist'
      }
    }
  },
  computed: {
    // 获取当前路由路径
    getDefaultActive() {
      switch (this.$route.path) {
        case '/orderdetail':
          return '/order'
        case '/detail':
          return '/goods'
        case '/casedetail':
          return '/demandcaselist'
        case '/servicecaseadd':
        case '/servicecasedetail':
          return '/servicecaselist'
        case '/myprojectdetail':
          return '/myproject'
        default:
          return this.$route.path
      }
    }
  },
  methods: {
    unlogin(){
       console.log("unlogin")
      var selfthis = this
      var url = "/api/api/index/unlogin"
      var postdata = {}
      commfun.ajaxGet(selfthis,url,postdata,function (selfthis,data){
        Cookies.set('token', '')
        Cookies.set('userName','')
        window.location.href="/"
        return true
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },
    // 判断指定值是否在指定数组中
    in_array (search, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === search) {
          return true;
        }
      }
      return false;
    },
    pwdreset(){  //修改密码
      window.location.href="/pwdreset"
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Mainl.vue